import styled from 'styled-components';
import {
  fontName,
  gray,
  lightGray,
  veryLightGray,
  linkBlue,
  linkHoverBlue,
  red,
  darkRed,
} from '../css/globals.styles';
import {TargetBlank} from '../util/links';
import WBIcon from './elements/WBIcon';

export const WysiwygNotice = styled.div`
  display: flex;
  justify-content: space-between;
  font-family: ${fontName};
  border: 1px solid ${veryLightGray};
  border-radius: 4px;
  padding: 12px 16px;
  margin-bottom: 32px;
`;

export const WysiwygNoticeSuccess = styled.div`
  display: flex;
  align-items: center;
`;

export const WysiwygNoticeSuccessIcon = styled(WBIcon)`
  flex-shrink: 0;
  font-size: 24px;
  margin-right: 8px;
`;

export const WysiwygNoticeLink = styled(TargetBlank)`
  color: ${lightGray};
  &:hover {
    color: ${gray};
  }
  && {
    text-decoration: underline;
  }
`;

export const WysiwygNoticeActions = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  margin-left: 32px;
`;

export const WysiwygConvert = styled.div`
  color: ${linkBlue};
  &:hover {
    color: ${linkHoverBlue};
  }
  cursor: pointer;
`;

export const WysiwygRevert = styled.div`
  color: ${red};
  &:hover {
    color: ${darkRed};
  }
  cursor: pointer;
`;

export const WysiwygDismiss = styled.div`
  color: ${lightGray};
  &:hover {
    color: ${gray};
  }
  cursor: pointer;
  margin-left: 24px;
`;
